/**
 * Format review feedback tag ids for display.
 * Prefers pay-landing labels; falls back to Title Case from snake_case.
 */

const KNOWN_TAG_LABELS = {
  attention_to_detail: 'Attention to detail',
  went_extra_mile: 'Went the extra mile',
  loved_experience: 'Loved the experience',
  friendly: 'Friendly',
  average_experience: 'Average experience',
  could_be_better: 'Could be better',
  okay_service: 'Okay service',
  slow_service: 'Slow service',
  poor_quality: 'Poor quality',
  not_satisfied: 'Not satisfied',
  unprofessional: 'Unprofessional',
};

export function formatReviewTagLabel(value) {
  const raw = String(value || '').trim();
  if (!raw) return '';
  const key = raw.toLowerCase().replace(/[\s-]+/g, '_');
  if (KNOWN_TAG_LABELS[key]) return KNOWN_TAG_LABELS[key];
  return raw
    .replace(/[_-]+/g, ' ')
    .replace(/\s+/g, ' ')
    .trim()
    .replace(/\b\w/g, (char) => char.toUpperCase());
}
